<div>
  <div
    class="d-none d-sm-block"
    id="nav_logo_box"
  >
    <div id="nav_logo_img"></div>
  </div>

  <div class="sidebar-nav">
    <div class="card-group" id="accordion">
      <div
        [ngClass]="{
          groupactive:
            activeRoute === '/users/messages'
        }"
        class="card tabMyAccount"
      >
        <div class="card-body">
          <div class="card-title">
            <a (click)="navigate('/users/messages')" [routerLink]="['/users/messages']">
              My Account</a
            >
          </div>
        </div>
      </div>

      <div
        [ngClass]="{ groupactive: activeRoute.startsWith(navItem.route) && (clicked === '' || clicked == null) }"
        class="card"
        *ngFor="let navItem of navigationItems"
      >
        <div class="card-body">
          <div class="card-title">
            <a (click)="navigate(navItem.route)" [routerLink]="[navItem.route]"
              ><i class="menuIcon" [ngClass]="navItem.icon"></i
              >{{ navItem.title }}</a
            >
          </div>
        </div>
      </div>
      <div
        [ngClass]="{ groupactive: merchant.descriptionLong === clicked }"
        class="card"
        *ngFor="let merchant of merchants"
      >
        <div class="card-body">
          <div class="card-title">
            <a (click)="selectMerchant(merchant)"
            ><i class="menuIcon fa fa-credit-card"></i
            >{{ merchant.descriptionLong }} Account</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-none d-md-block">
    <app-navigation-sidebar-footer></app-navigation-sidebar-footer>
  </div>
</div>
